import { Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import Layout from "./Shared/Layout";
import toast from "react-hot-toast";
import { get } from "../_services/apiService";
import { API_URL } from "../_services/apiUrl";
import Breadcrumb from "./Breadcrumb";

const Blog = () => {
    const [showModal, setShowModal] = useState(false);
    const [blogData, setBlogData] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null);

    const getShortDescription = (description, wordLimit = 15) => {
        if (!description) return "";
        const text = description.replace(/<\/?[^>]+(>|$)/g, "").trim();
        const words = text.split(/\s+/);
        return words.length > wordLimit
            ? words.slice(0, wordLimit).join(" ") + "..."
            : words.join(" ");
    };

    const handleModalToggle = (index) => {
        setActiveIndex(index);
        setShowModal(true);
    };

    const fetchBlogDetail = async () => {
        try {
            const response = await get(API_URL.blogs);

            if (response?.status === true && Array.isArray(response?.data)) {
                setBlogData(response.data);
            } else {
                setBlogData([]);
                toast.error(response?.message || "Blog data not found");
            }
        } catch (error) {
            setBlogData([]);
            toast.error("An error occurred. Please try again later.");
        }
    };

    const formatDate = (date) => {
        if (!date) return "";
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, "0");
        const month = (d.getMonth() + 1).toString().padStart(2, "0");
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    useEffect(() => {
        fetchBlogDetail();
    }, []);

    useEffect(() => {
        document.body.classList.toggle("blog-modal-open", showModal);

        return () => {
            document.body.classList.remove("blog-modal-open");
        };
    }, [showModal]);

    return (
        <Layout showBreadcrumb={false}>
            <section className="blog_main">
                <section className="contact-banner-sec">
                    <div className="container-fluid">
                        <div className="page-header">
                            <h1>My Blog</h1>
                        </div>
                        <Breadcrumb currentLabel="My Blog" />
                    </div>
                </section>
                <div className="container pb-sm-5 pb-2">
                    <div className="blog_content_shell">
                        <section className="blog_wepper_main">
                            <div className="blog_grid">
                                {blogData?.length > 0 ? (
                                    blogData.map((item, index) => (
                                        <div className="blog_grid_item" key={item?.id || index}>
                                            <article className="blog_wepper">
                                                <div className="blog_img_data">
                                                    <img
                                                        src={item?.image || "./images/defaultImage.png"}
                                                        alt={item?.title || "Blog"}
                                                        onError={(e) => {
                                                            e.target.src = "./images/defaultImage.png";
                                                        }}
                                                    />
                                                </div>

                                                <div className="blog_text_weper">
                                                    <span>{formatDate(item?.publish_date)}</span>
                                                    <h3>{item?.title}</h3>

                                                    {item?.writer && (
                                                        <h6 className="mb-2">By {item?.writer}</h6>
                                                    )}

                                                    <p>{getShortDescription(item?.description, 15)}</p>

                                                    <span
                                                        className="blog_read_more"
                                                        onClick={() => handleModalToggle(index)}
                                                    >
                                                        Read More
                                                    </span>
                                                </div>
                                            </article>
                                        </div>
                                    ))
                                ) : (
                                    <div className="blog_empty_state">
                                        <p>No blog data found</p>
                                    </div>
                                )}
                            </div>
                        </section>
                    </div>
                </div>

                {activeIndex !== null && (
                    <Modal
                        show={showModal}
                        onHide={() => setShowModal(false)}
                        dialogClassName="modal-xl"
                        className="blog-detail-modal"
                        centered
                        scrollable
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>{blogData[activeIndex]?.title}</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <div className="popup_content">
                                <img
                                    src={blogData[activeIndex]?.image || "./images/defaultImage.png"}
                                    alt={blogData[activeIndex]?.title || "Blog"}
                                    className="popup_image"
                                    onError={(e) => {
                                        e.target.src = "./images/defaultImage.png";
                                    }}
                                />

                                <br />
                                <span>{formatDate(blogData[activeIndex]?.publish_date)}</span>

                                {blogData[activeIndex]?.writer && (
                                    <p><strong>By:</strong> {blogData[activeIndex]?.writer}</p>
                                )}

                                <div className="description-box">
                                    <div
                                        className="word-wrap"
                                        dangerouslySetInnerHTML={{
                                            __html: blogData[activeIndex]?.description || "",
                                        }}
                                    />
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                )}
            </section>
        </Layout>
    );
};

export default Blog;
